import { createSlice } from "@reduxjs/toolkit";

const companySlice = createSlice({
  name: "company",
  initialState: [],
  reducers: {
    companyAdd(state, action) {
      return action.payload;
    },
    companyCreate(state, action) {
      const company = action.payload;
      state.push(company);
    },
    companyDelete(state, action) {
      const toDelete = state.findIndex(spec => spec.id === action.payload);
      if (toDelete > -1) state.splice(toDelete, 1);
    },
    companyEdit(state, action) {
      const company = action.payload;
      const companyIndex = state.findIndex(item => item.id === company.id);
      if (companyIndex !== -1) {
        state[companyIndex] = company;
      }
    },
  },
});

export const { companyAdd, companyCreate, companyDelete, companyEdit } = companySlice.actions;
export default companySlice.reducer;
